import SectionTitle from "../../../components/section-title";
import HomeData from "../../../data/home.json";
import MedicalFeature from "../../../components/medical-feature";

const MedicalFeatureContainer = () => {
    return (
        <section className="feature-section bg-white">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <SectionTitle
                            subTitle="진료 과목"
                            title="<span>정환교 피부과</span> 전문 진료 과목"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row academic-box-style" data-aos="fade-up" data-aos-duration="1100">
                            {HomeData[3].medicalFeature &&
                                HomeData[3].medicalFeature.map((single, key) => {
                                    return (
                                        <div key={key} className="col-md-6 col-lg-4">
                                            <MedicalFeature key={key} data={single} />
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <p className="pricing-note">
                            필요하지 않은 시술은 권하지 않습니다.
                            환자에게 꼭 필요한 치료만, 충분히 설명하고 진행합니다.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MedicalFeatureContainer;
